import Venue from '../framework/models/venue';
import Itinerary from '../framework/models/itinerary';

import CategorySet from '../framework/collections/category-set';
import VenueSet from '../framework/collections/venue-set';
import TripSet from '../framework/collections/trip-set';

import Screen from '../framework/views/screen';
import Checkbox from '../framework/views/checkbox';

import CollectionView from '../framework/collection-views/base';
import CardSet from '../framework/collection-views/card-set';
import CheckboxSet from '../framework/collection-views/checkbox-set';

import getAbout from '../service/about';
import setRating from '../service/rating';

export default function( $, app ) {
	var { model: session, profile } = app;

	var myVenues = session.stops;
	var addedVenues = new VenueSet();

	var categories = new CategorySet();

	var favourites = profile.get( 'favourites' ) || [];
	profile.on( 'change:favourites', () => {
		favourites = profile.get( 'favourites' ) || [];
		categoriesList.sortChildren();
	} );

	getAbout( html => $( '#about-content' ).html( html ) );

	// =========================
	// ! Setup Views
	// =========================

	function hideIfNoVenues() {
		this.$el.toggleClass( 'no-venues', this.model.get( 'count' ) === 0 );
		this.$el.toggleClass( 'no-events', this.model.get( 'eventCount' ) === 0 );
	}

	function sortByVenueCount( model ) {
		return model.get( 'count' ) * ( favourites.indexOf( model.id + '' ) >= 0 ? 100000 : 1 );
	}

	function sortByEventCount( model ) {
		return model.get( 'eventCount' ) * ( favourites.indexOf( model.id + '' ) >= 0 ? 100000 : 1 );
	}

	var categoriesList = new CardSet( {
		el: '#categories',
		collection: categories,
		childSort: [ sortByVenueCount, 'desc' ],
		childOptions: {
			template: '#tpl_category_card',
			listeners: { 'model change:count change:venueCount change:eventCount': hideIfNoVenues },
			on: { render: hideIfNoVenues },
		},
	} );

	categoriesList.render();

	app.on( 'filter:events_only', eventsOnly => {
		categoriesList.childSort[0] = eventsOnly ? sortByEventCount : sortByVenueCount;
		categoriesList.sortChildren();
	} );

	function flagIfEvent() {
		this.$el.toggleClass( 'is-event', this.model.get( 'time' ) !== '' );
	}

	var venuesList = new CheckboxSet( {
		el: '#venues',
		collection: new VenueSet(),
		checked: addedVenues,
		childOptions: {
			template: '#tpl_venue_preview',
			on: { render: flagIfEvent },
		},
	} );

	venuesList.render();

	venuesList.collection.on( 'update', function() {
		venuesList.reset( myVenues.models );
	} );

	addedVenues.on( 'add', ( venue, collection, options ) => {
		if ( ! options.reset ) {
			myVenues.add( venue );
		}
	} );

	addedVenues.on( 'remove', ( venue, collection, options ) => {
		if ( ! options.reset ) {
			myVenues.remove( venue );
		}
	} );

	var venueDetails = new Checkbox( {
		el: '#venue',
		model: new Venue(),
		events: {
			'input .-rating': function( e ) {
				this.model.set( 'rating', e.target.value );
				if ( session.get( 'uid' ) ) {
					setRating( {
						uid: this.model.id,
						userId: session.get( 'uid' ),
						rating: e.target.value,
					}, resp => {
						console.log( resp );
					} );
				}
			},
		},
		on: {
			render: flagIfEvent,
			select: function() {
				addedVenues.add( this.model );
			},
			unselect: function() {
				addedVenues.remove( this.model );
			},
			rebind: function() {
				this.change( myVenues.contains( this.model ), { silent: true } ).renderStatus();

				var rating = this.model.get( 'rating' ) + '';
				this.$( '.-rating' ).each( function() {
					this.checked = this.value === rating;
				} );
			},
		},
	} );

	venueDetails.render();

	var myItinerary = new CollectionView( {
		el: '#my_itinerary',
		collection: myVenues,
		defaultChecked: true,
		childOptions: {
			template: '#tpl_stop_preview',
			events: {
				'click .-remove': function() {
					addedVenues.remove( this.model );
				},
			},
		},
	} );

	myItinerary.render();

	var someItinerary = new Itinerary();

	var viewItinerary = new Screen( {
		el: '#view_itinerary',
		model: someItinerary,
	} );

	viewItinerary.stops = new CollectionView( {
		el: '#view_itinerary',
		collection: someItinerary.stops,
		defaultChecked: true,
		childOptions: {
			template: '#tpl_stop_preview',
		},
	} );

	viewItinerary.render();
	viewItinerary.stops.render();

	var myTrips = new TripSet();

	var tripsList = new CardSet( {
		el: '#trips',
		collection: myTrips,
		childSort: [ 'date', 'desc' ],
		childOptions: {
			template: '#tpl_trip_item',
		},
	} );

	tripsList.render();

	var favCategories = new CheckboxSet( {
		el: '#fav_categories',
		collection: categories,
		childOptions: {
			template: '#tpl_fav_item',
		},
	} );

	favCategories.render();

	// =========================
	// ! Expose to app object
	// =========================

	app.views = { categoriesList, venuesList, venueDetails, myItinerary, viewItinerary, tripsList, favCategories };
}
